let mapApiKey = "AIzaSyAPxTjfw3OFXpqGODjQEMYIBH2LSSYNn0w";

if (process.env.REACT_APP_FIREBASE_PROD === "YES") {
  mapApiKey = "AIzaSyBaySnNT8RjyYXFTw2bGFyCxVu0GgWQsj4";
}

export default mapApiKey;
